module.exports = __webpack_public_path__ + "static/media/barbatimao.ee2a1ee8.png";